module.exports = __webpack_public_path__ + "img/MentalHealth.f9b28f60.svg";